export type { CodeNavLocation, CodeNavSymbolSpan, SymbolTag, CodeNavDefinitionsResult } from './types.js';
export { buildSymbolIndexAsync } from './symbol-index/build/build-symbol-index.js';
export { ensureSymbolIndexAsync } from './symbol-index/build/ensure-symbol-index.js';
export { symbolIndexIsPopulated } from './symbol-index/sqlite/symbol-index-sqlite.js';
export {
  loadSymbolIndexReadyFileSet,
  symbolIndexFileIsReadyAsync,
} from './symbol-index/lifecycle/symbol-index-file-ready.js';
export { ensureSymbolIndexFileAsync } from './symbol-index/build/ensure-symbol-index-file.js';
export { updateSymbolIndexForFile, removeSymbolIndexForFile } from './symbol-index/build/update-symbol-index-file.js';
export {
  queryDefinitionAt,
  queryDefinitionsAt,
  queryDefinitionsNavigation,
  queryReferencesAt,
  querySymbolsInFile,
} from './symbol-index/query/query-symbol-index.js';
export { isCodeNavSupportedPath } from './language-registry.js';
